module.exports = __webpack_public_path__ + "img/vi.1c60a5b6.svg";